import React from "react";

const MinimizeIcon = (props: any) => {
  return (
    <svg width={18} height={18} fill="none" {...props}>
      <path
        fill="var(--color-icon-bright)"
        d="M9.632 3.07c.308 0 .563.255.563.563V7.57h3.937c.308 0 .563.255.563.563a.567.567 0 0 1-.563.562h-4.5a.567.567 0 0 1-.562-.562v-4.5c0-.308.255-.563.562-.563ZM2.955 9.078h4.5c.308 0 .563.255.563.563v4.5a.567.567 0 0 1-.563.562.567.567 0 0 1-.562-.562v-3.938H2.955a.567.567 0 0 1-.562-.562c0-.308.255-.563.562-.563Z"
      />
      <path
        fill="var(--color-icon-bright)"
        d="M10.125 8.438a.556.556 0 0 1-.397-.165.566.566 0 0 1 0-.795l5.625-5.625a.566.566 0 0 1 .795 0 .566.566 0 0 1 0 .795l-5.625 5.625a.556.556 0 0 1-.398.165ZM1.56 16.31a.556.556 0 0 1-.397-.164.566.566 0 0 1 0-.795l5.625-5.625a.566.566 0 0 1 .795 0 .566.566 0 0 1 0 .795l-5.625 5.625a.556.556 0 0 1-.397.165Z"
      />
    </svg>
  );
};

export default MinimizeIcon;
